import { render, staticRenderFns } from "./ModalReqTransferProducts.vue?vue&type=template&id=2e70e9d0&scoped=true"
import script from "./ModalReqTransferProducts.vue?vue&type=script&lang=js"
export * from "./ModalReqTransferProducts.vue?vue&type=script&lang=js"
import style0 from "./ModalReqTransferProducts.vue?vue&type=style&index=0&id=2e70e9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70e9d0",
  null
  
)

export default component.exports